
export const RoleRoute = ({ children, role, allowedRoles=[]}) => {
  return (JSON.stringify(allowedRoles)=== JSON.stringify([])) || allowedRoles.includes(role)
    ? children
    : <></>
}
